/**
 * Tola AI settings sit loose between the groups, one leaf for the whole
 * surface. The route meta carries the Captain feature flag and admin gate.
 */
export default ({ t, accountScopedRoute }) => ({
  name: 'Settings Tola AI',
  label: t('SIDEBAR.CAPTAIN'),
  icon: 'i-ph-sparkle',
  to: accountScopedRoute('captain_settings_index'),
});
